export default "__VITE_ASSET__888d088d__"